<template>
    <div class="group-filter-bg px-md-4 py-md-4">
      <div class="row pt-0 mr-lg-4 justify-content-between">
        <div :class="`col-sm-6 col-xl-${col}`">
          <div class="form-group">
            <input
              v-model.trim="applicantFirstName"
              id="applicantFirstName"
              name="applicantFirstName"
              type="text"
              autofocus
              placeholder="Prénom"
              class="form-control"
            />
          </div>
        </div>
        <div :class="`col-sm-6 col-xl-${col}`">
          <div class="form-group">
            <input
              v-model.trim="applicantLastName"
              id="applicantLastName"
              name="applicantLastName"
              type="text"
              autofocus
              placeholder="Nom"
              class="form-control"
            />
          </div>
        </div>
      </div>
      <div class="row pt-0 mr-lg-4 justify-content-between">
        <!-- Group Filter -->
  
        <div
          :class="`col-sm-6 col-xl-${col}`"
          v-if="$route.path != '/personalTasks'"
        >
          <div class="group-filter">
            <div class="form-group">
              <select class="form-control" v-model="selectedStatus">
                <option value="">Statut</option>
                <option
                  v-for="(status, index) in statusList"
                  :value="status"
                  :key="index"
                >
                  {{
                    statusListTranslation[status]
                      ? statusListTranslation[status]
                      : "Régie à traiter"
                  }}
                </option>
              </select>
              <div class="select-down">
                <img
                  class="select-down__icon"
                  src="@/assets/images/down-arrow.svg"
                  alt="Arrow Icon"
                  aria-hidden="true"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          :class="`col-sm-6 col-xl-${col}`"
        >
          <div class="group-filter">
            <div class="form-group">
              <select class="form-control" v-model="selectedStructureID">
                <option value="">Structure</option>
                <option
                  v-for="(structure, index) in structureList"
                  :value="structure.reference"
                  :key="index"
                >
                  {{ structure.name }}
                </option>
              </select>
              <div class="select-down">
                <img
                  class="select-down__icon"
                  src="@/assets/images/down-arrow.svg"
                  alt="Arrow Icon"
                  aria-hidden="true"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Report for Filter -->
        <div :class="`col-sm-6 col-xl-${col} mb-3 mb-md-0`">
          <div class="d-flex common-filter">
            <div class="p-2 icon">
              <i class="far fa-calendar"></i>
            </div>
            <div>
              <d-datepicker id="dateFrom" class="pr-1" v-model="startDate" placeholder="date début" :input-class="['form-control']" :language="fr" small></d-datepicker>
            </div>
          </div>
        </div>
        <!-- Date added -->
        <div :class="`col-sm-6 col-xl-${col} mb-3 mb-xl-0`">
          <div class="d-flex common-filter">
            <div class="p-2 icon">
              <i class="far fa-calendar"></i>
            </div>
            <div>
              <d-datepicker id="dateTo" class="pr-1" v-model="endDate" placeholder="date fin" :input-class="['form-control']" :language="fr" small></d-datepicker>
            </div>
          </div>
        </div>
        <!-- Apply Button -->
        <div :class="`only-desk-top col-sm-6 col-xl-${col} mb-3 mb-md-0 d-flex`">
          <div class="task-manager-apply" style="margin-left: 5px">
            <button class="btn btn-primary" @click="saveSearch()">
              {{ $t("global.apply") }}
            </button>
          </div>
          <div class="task-manager-apply" style="margin-left: 5px">
            <button class="btn btn-primary" @click="refresh()">
              {{ $t("global.reset") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { fr } from "vuejs-datepicker/dist/locale";
  
  export default {
    data() {
      return {
        selectedStatus: "",
        startDate: null,
        endDate: null,
        type: "",
        hideGroupFilter: true,
        fr,
        statusListTranslation: {
          ACCEPTED: "Régie approuvée",
          REFUSED: "Régie rejetée",
          TREATED: "Régie traitée"
        },
        firstNameDemander: "",
        lastNameDemander: "",
        applicantFirstName: "",
        applicantLastName: "",
        structureList: null,
        selectedStructureID: ""
      };
    },
    props: ["statusList"],
    mounted() {
      this.$services.structure
        .findAll()
        .then((response) => {
          this.structureList = response.data;
        })
    },
    computed: {
      col() {
        return this.hideGroupFilter ? 3 : 3;
      }
    },
    methods: {
      saveSearch() {
        const obj = {};
        if (this.applicantFirstName) {
          obj.applicantFirstName = this.applicantFirstName;
        }
        if (this.applicantLastName) {
          obj.applicantLastName = this.applicantLastName;
        }
        // if (this.applicantFirstName) {
        //   obj.firstName = this.applicantFirstName;
        // }
        // if (this.applicantLastName) {
        //   obj.lastName = this.applicantLastName;
        // }
        // if (this.firstNameDemander) {
        //   obj.applicantFirstName = this.firstNameDemander;
        // }
        // if (this.lastNameDemander) {
        //   obj.applicantLastName = this.lastNameDemander;
        // }
        if (this.selectedStatus !== "") {
          obj.status = this.selectedStatus;
        }
        if (this.startDate !== "") {
          obj.startDate = this.startDate;
        }
        if (this.endDate !== "") {
          obj.endDate = this.endDate;
        }
        if (this.selectedStructureID !== "") {
          obj.structureID = this.selectedStructureID;
        }
        this.$store.dispatch("setFilter", obj);
        this.$root.$emit("searchRequests", obj);
      },
  
      refresh() {
        this.selectedStatus = "";
        this.startDate = "";
        this.endDate = "";
        this.selectedStructureID = "";
        this.applicantFirstName = "";
        this.applicantLastName = "";
        // this.firstNameDemander = "";
        // this.lastNameDemander = "";
        this.saveSearch();
      }
    }
  };
  </script>
  <style lang="scss">
  .form-control {
    background-color: #fff !important;
  }
  .group-filter {
    position: relative;
    select {
      background: white !important;
      color: black !important;
      text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4) !important;
      background-repeat: no-repeat;
      -webkit-appearance: none;
      -moz-appearance: none;
      position: relative;
    }
    .select-down {
      position: absolute;
      right: 10px;
      top: 5px;
      &__icon {
        width: 13px;
      }
    }
  }
  .task-manager-apply {
    .task-manager-btn {
      width: 110px;
      height: 36px;
      border: 0;
      background-color: #4f78e2;
      color: #fff;
      font-family: "SF-Pro-Text";
      border-radius: 3px;
      font-size: 14px;
      margin-right: 15px; //9
      outline: none;
    }
  }
  </style>
  